<template>
    <TTiles />
</template>

<script>
import TTiles from '../../../templates/terminal/t-tiles';

export default {
    name: 'PTiles',
    components: {
        TTiles
    }
}
</script>